import { Item, MenuItem } from "../../../../components/Menu";
import { LocalizationMessages } from "../../../../localization/messages";
import PropTypes from "prop-types";
import React from "react";
import { UISelectors } from "../../../../redux/selectors";
import { UrlUtils } from "../../../../utils";
import { useCommunicationHandlers } from "../../../UsefulLinks";
import { useSelector } from "react-redux";
import { useFeature } from "../../../../hooks/useFeature";
import { AppFeatures } from "../../../../constants/featureFlags";

export const ContactUsMenuItem = props => {
  const { trackingInfo } = props;
  const isCustomerRelationsActive = useFeature(AppFeatures.CUSTOMER_RELATIONS);
  const links = useSelector(UISelectors.links);
  const { handleContactUs } = useCommunicationHandlers();
  const contactUsItem = new Item({
    URL: !isCustomerRelationsActive
      ? UrlUtils.getNativeLink(links.contactUs)
      : undefined,
    title: LocalizationMessages.contactUs,
    iconKey: "email",
    target: "SendEmailTab"
  });

  return (
    <MenuItem
      item={contactUsItem}
      automationId="uc-contact-us"
      dataTestId="contact-us"
      trackingInfo={trackingInfo}
      ignoreNavigation={true}
      onClick={isCustomerRelationsActive ? handleContactUs : undefined}
      className={"userarea-section-links-last"}
    />
  );
};

ContactUsMenuItem.propTypes = {
  trackingInfo: PropTypes.object
};
